import { DeflateRaw, InflateRaw } from "@pdfking/io"
import {
  Base64URLDecode,
  Base64URLEncode,
  Composition,
  JSONDecode,
  JSONEncode,
  StringToUInt8,
  UInt8ToString,
} from "@pdfking/tfunc"

// Route state travels in the URL fragment, so it is deflated before base64:
// imposition payloads carry long field names and repeat their structure per
// component and job, which raw deflate collapses to a fraction of the plain
// JSON. `pyfuncs.api.urlstate` is the Python half of this exact format — it is
// what `frontend_url` builds its links with — so a backend-built link decodes
// here and one built here decodes there.
export const EncodeState = Composition(JSONEncode, StringToUInt8, DeflateRaw, Base64URLEncode) as <
  T,
>(
  state: T
) => string

export const DecodeState = Composition(Base64URLDecode, InflateRaw, UInt8ToString, JSONDecode) as <
  T,
>(
  encoded: string
) => T
